<template>
    <v-layout align-center justify-center row pa-5 my-12>
        <v-flex xs12 sm10 md6 text-center>
            <div class="mb-5">
                <h1>เลขทะเบียน</h1>
            </div>
            <div>
                <v-text-field
                        label="Barcode"
                        placeholder="พิมพ์ หรือ สแกนบาร์โค้ด"
                        outlined
                        :error="error"
                        append-icon="mdi-barcode-scan"
                        @click:append="dialog2 = true"
                        v-model="barcode"
                ></v-text-field>
            </div>
        </v-flex>
        <v-dialog v-model="dialog" max-width="290">
            <v-card>
                <v-card-title class="headline">รหัสบาร์โค้ดซ้ำ</v-card-title>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1" text @click="dialog = false">
                        ตกลง
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog2" max-width="290">
            <v-card>
                <v-card-actions>
                    <v-row>
                        <v-col>
                            <v-btn color="green darken-1" outlined block @click="goto('barcode-scan-waiting')">
                                Barcode
                            </v-btn>
                        </v-col>
                        <v-col>
                            <v-btn color="green darken-1" outlined block @click="goto('qrcode-scan-waiting')">
                                QR Code
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import axios from "@/axios";
    import EventBus from '@/EventBus'

    export default {
        name: "Step1",
        data() {
            return {
                barcode: '',
                dialog: false,
                dialog2: false,
                error: false
            }
        },
        mounted() {
            if(this.getLocalItem().barcode){
                this.barcode = this.getLocalItem().barcode
            }
        },
        methods: {
            goto(route_name) {
                return this.$router.push({name: route_name})
            },
            async checkBarcode(val) {
                try {
                    axios.post("/CheckBarcode", {
                        barcode: val,
                        nt_runno: this.getLocalItem().nt_runno,
                    }).then((res) => {
                        if (res.data.data.length > 0) {
                            this.dialog = true
                            this.error = true
                            let params = {step: 1, isData: false, barcode: ''}
                            EventBus.$emit('step_submit', params)
                            // console.log("CheckBarcode", "if");
                        } else {
                            this.error = false
                            let params = {step: 1, isData: true, barcode: val}
                            EventBus.$emit('step_submit', params)

                            // console.log("CheckBarcode", "else");
                        }
                    });
                } catch (err) {
                    console.log("CheckBarcode", err.message);
                }
            }
        },
        watch: {
            barcode: function (val) {
                if (val) {
                    this.checkBarcode(val)
                } else {
                    let params = {step: 1, isData: false, barcode: ''}
                    EventBus.$emit('step_submit', params)
                }
            }
        }
    }
</script>

<style scoped>

</style>